import { LooseAutocomplete } from '@b2b/types/core';
import angular from 'angular';

export interface SessionTimeout {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

export interface CCValidationSettings {
  b2bValidation: string;
  b2bDisplay: string;
  b2cValidation: string;
  b2cDisplay: string;
  posValidation?: string;
  posDisplay?: string;
}

export interface CCValidationSettingsOption {
  label: string;
  display: LooseAutocomplete<'Address' | 'Zipcode' | 'None'>;
  validation: LooseAutocomplete<'Zipcode' | 'None'>;
}

export interface CCValidationSettingsOptions {
  b2b: CCValidationSettingsOption;
  b2c: CCValidationSettingsOption;
}

export interface EmailTemplate {
  id?: string;
  templateType: string;
  emailType: { id: string };
  externalTemplateId: string;
  sendGridAcount: { id: string };
}

export interface EmailTemplateMarshall {
  id?: string;
  templateType: EmailTemplate['templateType'];
  externalTemplateId: string;
  useAcmeKey: boolean;
}

export class AccountAdministrationService {
  static $inject = [];

  constructor() {}

  getSessionTimeoutInMS(sessionTimeout: SessionTimeout): number {
    let milliseconds = 0;
    milliseconds += sessionTimeout.seconds * 1000;
    milliseconds += sessionTimeout.minutes * 60 * 1000;
    milliseconds += sessionTimeout.hours * 60 * 60 * 1000;
    milliseconds += sessionTimeout.days * 24 * 60 * 60 * 1000;

    return milliseconds;
  }

  convertSessionTimeoutToMS(milliseconds: number): SessionTimeout {
    const seconds = milliseconds / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;

    return {
      seconds: Math.trunc(seconds % 60),
      minutes: Math.trunc(minutes % 60),
      hours: Math.trunc(hours % 24),
      days: Math.trunc(days),
    };
  }

  getCCVSettings(settings: CCValidationSettingsOptions): CCValidationSettings {
    return {
      b2bValidation: settings.b2b.validation,
      b2bDisplay: settings.b2b.display,
      b2cValidation: settings.b2c.validation,
      b2cDisplay: settings.b2c.display,
    };
  }

  updateCCVSettings(
    settings: CCValidationSettingsOptions,
    rawSettings: CCValidationSettings
  ): CCValidationSettingsOptions {
    for (const rawKey of Object.keys(rawSettings)) {
      if (rawSettings[rawKey]) {
        const parts = rawKey.split(/(V|D)/); // e.g. "b2bDisplay".split(/(V|D)/) => ['b2b', 'D', 'isplay']
        const type = parts[0];
        const key = (parts[1] + parts[2]).toLowerCase();

        if (parts.length && settings[type]) {
          switch (key) {
            case 'validation':
              settings[type].validation = rawSettings[rawKey];
              break;

            case 'display':
              settings[type].display = rawSettings[rawKey];
              break;
          }
        }
      }
    }

    return settings;
  }
}

export const AccountAdministrationServiceModule = angular
  .module('acme.view.application.account.administration.service', [])
  .service('AccountAdministrationService', AccountAdministrationService).name;
